import * as React from 'react';
import { connect } from 'react-redux';
import store from '../store/store';
import types from '../store/types';
import { EModalType } from '../helpers';
import { IDropdownOption } from 'office-ui-fabric-react';
import { JourneyTypeDialog } from '../components/layout/journey-type-dialog';

class JourneyTypeContainer extends React.Component<any, any> {

    closeDialog = (save?: boolean) => {

        let typeOfJourneys = this.props.journeyTypes;
        // Save the outputs
        if (save)
            for (let i = 0; i < typeOfJourneys.length; i++) {
                const mappedJourneys = typeOfJourneys.map((d) => d.selected);
                if (mappedJourneys[i] === true) {
                    this.updateJourneyType(typeOfJourneys[i])
                    store.dispatch({ type: types.UPDATE_JOURNEY_TYPE, journeyTypes: typeOfJourneys[i] });
                }
            }

        store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });

    }
    updateJourneyType = (typeOfJourney: IDropdownOption) => {

        switch (typeOfJourney.text) {
            case "Shared Journey":
                store.dispatch({ type: types.UPDATE_IS_SHARED_JOURNEY, isSharedJourney: true });
                break;
            case "Triage Journey":
                store.dispatch({ type: types.UPDATE_IS_TRIAGE_JOURNEY, isTriageJourney: true });
                break;
            case "Page Journey":
                store.dispatch({ type: types.UPDATE_IS_PAGE_JOURNEY, isPageJourney: true });
                break;
            default:
                break;
        }

    }

    journeyTypeChange = (item: IDropdownOption) => {
        let typeOfJourneys = this.props.journeyTypes;

        for (let i = 0; i < typeOfJourneys.length; i++) {
            const mappedJourneys = typeOfJourneys.map((d) => d.selected);
            if (mappedJourneys[i] === true) {
                if (typeOfJourneys[i] && item) {
                    typeOfJourneys[i].selected = false;
                }
            }
        }
        item.selected = true;
    }
    public render() {

        let selectedJourneyType = this.props.journeyTypes[0].key;

        return <JourneyTypeDialog
            closeDialog={this.closeDialog}
            journeyTypes={this.props.journeyTypes}
            journeyTypeChange={this.journeyTypeChange}
            selectedJourneyType={selectedJourneyType}
        />;
    }
}

const mapStateToProps = (store) => {

    return {
        state: store.toolsState,
        journeyTypes: store.cacheState.journeyTypes
    };
};

export default connect<any, any, any>(mapStateToProps)(JourneyTypeContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/journey-type-config.tsx